import React, { useEffect, useRef } from 'react';
import './LoadingMessage.css';

const LoadingMessage = () => {
  const svgRef = useRef(null);

  useEffect(() => {
    if (!svgRef.current) return;

    const lines = svgRef.current.querySelectorAll('.line');
    const firstNeonColor = 'white';
    const secondNeonColor = '#63a3c9';

    const firstLines = Array.from(lines).slice(0, lines.length - 3);
    const lastLines = Array.from(lines).slice(lines.length - 3);

    const animateAllLines = () => {
      const allLines = [...firstLines, ...lastLines];

      allLines.forEach((line) => {
        const pathLength = line.getTotalLength();
        line.setAttribute('stroke-dasharray', pathLength);
        line.setAttribute('stroke-dashoffset', pathLength);
        const color = firstLines.includes(line) ? firstNeonColor : secondNeonColor;
        line.setAttribute('stroke', color);
        line.style.transition = 'stroke-dashoffset 1.2s ease-in-out';
      });

      requestAnimationFrame(() => {
        allLines.forEach((line) => {
          line.setAttribute('stroke-dashoffset', '0');
        });
      });

      setTimeout(() => {
        allLines.forEach((line) => {
          const pathLength = line.getTotalLength();
          line.style.transition = 'stroke-dashoffset 0.8s ease-in-out';
          line.setAttribute('stroke-dashoffset', pathLength);
        });

        setTimeout(() => {
          allLines.forEach((line) => {
            line.style.transition = 'none';
          });
          setTimeout(animateAllLines, 300); // restart after a short delay
        }, 800 + 300); // wait for reverse + hold
      }, 1500); // forward duration + hold
    };

    animateAllLines();
  }, []);

  return (
    <div className='wrapper'>
        <svg ref={svgRef}
        viewBox="0 0 500 100"
        width="500"
        height="100"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g fill="none"
          fillRule="evenodd"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2">
          <path className="line" d="M4 90v-34.26c.567-18.747 15.39-33.74 34-33.74 18.778 0 34 15.222 34 34v34h-17v-34c0-9.389-7.611-17-17-17-9.225 0-16.66 7.48-17 17.136v33.864h-17z" />
          <path className="line" d="M55 90v-34.26c.567-18.747 15.39-33.74 34-33.74 18.778 0 34 15.222 34 34v34h-17v-34c0-9.389-7.611-17-17-17-9.225 0-16.66 7.48-17 17.136v33.864h-17z" />
          <path className="line" d="M135.5 22a8.5 8.5 0 1 1-8.477 9.067v-1.134c.283-4.42 3.966-7.933 8.477-7.933z" />
          <path className="line" d="M128 47.5 H145 V90 H128 Z" />
          <path className="line" d="M150 90v-34.26c.567-18.747 15.39-33.74 34-33.74 18.778 0 34 15.222 34 34v34h-17v-34c0-9.389-7.611-17-17-17-9.225 0-16.66 7.48-17 17.136v33.864h-17z" />
          <g transform="translate(-7, 0)">
            <path className="line" d="M263 73c-9.389 0-17-7.611-17-17s7.611-17 17-17c9.18 0 16.58 7.4 17 17h-17v17h34V55.875C296.433 36.994 281.61 22 263 22c-18.778 0-34 15.222-34 34s15.222 34 34 34V73z" />
          </g>
          <g transform="translate(-15, -10)">
            <path
              className="line"
              d="M605 90V34h17v10c2.5-7 9.3-12 17-12h14v17h-14c-6.6 0-12 5.4-12 12v29h-22z"
              transform="matrix(0.943396, 0, 0, 1.071428, -261.698048, 3.571448)"
            />
          </g>
          <g transform="translate(-20, -13)">
            <path
              className="line"
              d="M625 56l20 68h10l20-68h-17l-8 30-8-30h-17z"
              transform="matrix(1.063829787, 0, 0, 0.882352941, -300.106383, -9.4117647)"
            />
          </g>
          <g transform="translate(388, 0)">
            <path className="line" d="M59 90V56.136C58.66 46.48 51.225 39 42 39c-9.389 0-17 7.611-17 17s7.611 17 17 17h8.5v17H42C23.222 90 8 74.778 8 56s15.222-34 34-34c18.61 0 33.433 14.994 34 33.875V90H59z" />
          </g>
        </g>
      </svg>
    </div>
  );
};

export default LoadingMessage;

/*
import React, { useEffect, useRef } from 'react';
import './LoadingMessage.css';

const LoadingMessage = () => {
  const svgRef = useRef(null);

useEffect(() => {
  if (!svgRef.current) return;

  const lines = svgRef.current.querySelectorAll('.line');
  const firstNeonColor = 'white';
  const secondNeonColor = '#63a3c9';

  const firstLines = Array.from(lines).slice(0, lines.length - 3);
  const lastLines = Array.from(lines).slice(lines.length - 3);
  const allLines = [...firstLines, ...lastLines];

  allLines.forEach((line) => {
    const pathLength = line.getTotalLength();
    line.setAttribute('stroke-dasharray', pathLength);
    line.setAttribute('stroke-dashoffset', pathLength);
    const color = firstLines.includes(line) ? firstNeonColor : secondNeonColor;
    line.setAttribute('stroke', color);
    line.style.transition = 'none';
    line.getBoundingClientRect(); // 🟢 FORCE REFLOW
  });

  const drawLines = () => {
    allLines.forEach((line, i) => {
      line.style.transition = `stroke-dashoffset 1s ease ${i * 0.05}s`;
      line.setAttribute('stroke-dashoffset', '0');
    });
  };

  const reverseLines = () => {
    allLines.forEach((line, i) => {
      const pathLength = line.getTotalLength();
      line.style.transition = `stroke-dashoffset 0.8s ease ${i * 0.03}s`;
      line.setAttribute('stroke-dashoffset', pathLength);
    });
  };

  const drawDuration = 1000;
  const holdDuration = 1000;
  const reverseDuration = 800;
  const delayAfterReverse = 300;

  const animate = () => {
    requestAnimationFrame(() => {
      drawLines();
    });

    setTimeout(() => {
      reverseLines();

      setTimeout(() => {
        animate();
      }, reverseDuration + delayAfterReverse);
    }, drawDuration + holdDuration);
  };

  animate();
}, []);


  return (
    <div className='wrapper'>
        <svg ref={svgRef}
        viewBox="0 0 500 100"
        width="500"
        height="100"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g fill="none"
          fillRule="evenodd"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2">
          <path className="line" d="M4 90v-34.26c.567-18.747 15.39-33.74 34-33.74 18.778 0 34 15.222 34 34v34h-17v-34c0-9.389-7.611-17-17-17-9.225 0-16.66 7.48-17 17.136v33.864h-17z" />
          <path className="line" d="M55 90v-34.26c.567-18.747 15.39-33.74 34-33.74 18.778 0 34 15.222 34 34v34h-17v-34c0-9.389-7.611-17-17-17-9.225 0-16.66 7.48-17 17.136v33.864h-17z" />
          <path className="line" d="M135.5 22a8.5 8.5 0 1 1-8.477 9.067v-1.134c.283-4.42 3.966-7.933 8.477-7.933z" />
          <path className="line" d="M128 47.5 H145 V90 H128 Z" />
          <path className="line" d="M150 90v-34.26c.567-18.747 15.39-33.74 34-33.74 18.778 0 34 15.222 34 34v34h-17v-34c0-9.389-7.611-17-17-17-9.225 0-16.66 7.48-17 17.136v33.864h-17z" />
          <g transform="translate(-7, 0)">
            <path className="line" d="M263 73c-9.389 0-17-7.611-17-17s7.611-17 17-17c9.18 0 16.58 7.4 17 17h-17v17h34V55.875C296.433 36.994 281.61 22 263 22c-18.778 0-34 15.222-34 34s15.222 34 34 34V73z" />
          </g>
          <g transform="translate(-15, -10)">
            <path
              className="line"
              d="M605 90V34h17v10c2.5-7 9.3-12 17-12h14v17h-14c-6.6 0-12 5.4-12 12v29h-22z"
              transform="matrix(0.943396, 0, 0, 1.071428, -261.698048, 3.571448)"
            />
          </g>
          <g transform="translate(-20, -13)">
            <path
              className="line"
              d="M625 56l20 68h10l20-68h-17l-8 30-8-30h-17z"
              transform="matrix(1.063829787, 0, 0, 0.882352941, -300.106383, -9.4117647)"
            />
          </g>
          <g transform="translate(388, 0)">
            <path className="line" d="M59 90V56.136C58.66 46.48 51.225 39 42 39c-9.389 0-17 7.611-17 17s7.611 17 17 17h8.5v17H42C23.222 90 8 74.778 8 56s15.222-34 34-34c18.61 0 33.433 14.994 34 33.875V90H59z" />
          </g>
        </g>
      </svg>
    </div>
  );
};

export default LoadingMessage;
*/
